import { render, staticRenderFns } from "./RecreateModal.vue?vue&type=template&id=4a51c0ee&scoped=true&"
import script from "./RecreateModal.vue?vue&type=script&lang=js&"
export * from "./RecreateModal.vue?vue&type=script&lang=js&"
import style0 from "./RecreateModal.vue?vue&type=style&index=0&id=4a51c0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a51c0ee",
  null
  
)

export default component.exports